<template>
<footer class="G_DisplayRowNowrap L_FooterHolder">
    <div class="L_SocialMediaHolders">
        <span class="L_SocialMediaIconHolder">
            <span class="fa G_DisplayRowNowrap G_BorderRadius L_SocialMediaIcon">&#xf09a;</span>
            <span class="fa G_DisplayRowNowrap G_BorderRadius L_SocialMediaIcon">&#xf16d;</span>
        </span>
    </div>
    <div class="G_DisplayColumnNowrap L_NavigationHolder">
        <span class="G_DisplayColumnNowrap G_HeadingFont L_NavigationColumnItem" v-for="FooterItem in TSTFooterItems" :key="FooterItem" v-html="FooterItem" @click="SetSelectedComp(FooterItem)">
        </span>
    </div>
    <div class="G_DisplayColumnNowrap G_HeadingFont L_OperatingHoursHolder">
        <div>Sunday & Monday: Closed</div>
        <div>Tuesday-Friday: 9am-5pm. Baked on pre-orders.</div>
        <div>Saturday: 9am-12pm. Collections only.</div>
    </div>
</footer>
</template>

<script>
export default {
    name: 'TSTFooter',
    data() {
        return {
            TSTFooterItems: [
                'Home',
                'Shop',
                'Contact Us'
            ]
        }
    },
    methods: {
        SetSelectedComp(FooterItem) {
            this.$emit('SetSelectedComp', FooterItem)
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/GlobalCss.scss";

.L_FooterHolder {
    width: 100%;
    height: 20rem;
    justify-content: center;
    align-items: center;
    border-top: #F3CBBB solid .2rem;

    @include mobile() {
        justify-content: space-around;
    }
}

.L_SocialMediaHolders {
    width: 20%;
    height: 100%;

    @include mobile() {
        width: 10%;
    }
}

.L_SocialMediaIconHolder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    font-size: 2rem;

    @include mobile() {
        flex-flow: column nowrap;
    }
}

.L_SocialMediaIcon {
    width: 3rem;
    height: 3rem;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    background-color: #F3CBBB;
    cursor: pointer;
}

.L_SocialMediaIcon:last-child {
    margin-left: 2rem;

    @include mobile() {
        margin-left: 0;
        margin-top: 1rem;
    }
}

.L_NavigationHolder {
    width: 30%;
    height: 50%;
    justify-content: space-around;
    align-items: center;

    @include mobile() {
        width: 20%;
        height: 60%;
        text-align: center;
    }
}

.L_NavigationColumnItem {
    width: 35%;
    height: 20%;
    justify-content: space-around;
    align-items: center;
}

.L_NavigationColumnItem:hover {
    color: #F3CBBB;
    text-decoration: underline;
    transition: 0.5s;
    cursor: pointer;
}

.L_OperatingHoursHolder {
    width: 40%;
    height: 80%;
    align-items: center;
    justify-content: space-around;
    text-align: center;

    @include mobile() {
        width: 50%;
    }
}
</style>
